import {CheckoutLegacyMutationsCreateCartArgs, VolatileCartResponse} from '@wix/wixstores-graphql-schema-node';
import {SPECS} from '../specs';
import {STORES_APP_DEF_ID} from '@wix/wixstores-client-core/dist/src/constants';
import {ICustomTextFields} from '@wix/wixstores-client-core/dist/src/types/product';
import {ReadOnlyExperiments} from '@wix/wix-experiments';

export class CheckoutApiService {
  constructor(private readonly wixCodeApi: any, private readonly experiments?: ReadOnlyExperiments) {}

  public async createCart(createCartParams: CheckoutLegacyMutationsCreateCartArgs): Promise<VolatileCartResponse> {
    return this.createCheckout(createCartParams);
  }

  private async createCheckout(createCartParams: CheckoutLegacyMutationsCreateCartArgs): Promise<VolatileCartResponse> {
    const publicApi: any = await this.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
    const isReturnCartIdNullInsteadOfDeprecatedForExpressService = this.experiments?.enabled(
      SPECS.ReturnCartIdNullInsteadOfDeprecatedForExpressService
    );

    const checkout = await publicApi.checkout.createCheckout(
      createCartParams.productId,
      createCartParams.quantity,
      {
        customTextFields: createCartParams.customTextFieldSelection as ICustomTextFields[],
        choices: createCartParams.options,
        optionsSelectionsIds: createCartParams.optionSelectionId,
        subscriptionOptionId: createCartParams.subscriptionOptionId,
        variantId: createCartParams.variantId,
      },
      createCartParams.preOrderRequested
    );

    return {
      id: isReturnCartIdNullInsteadOfDeprecatedForExpressService ? undefined : 'deprecated', // Cart ID is no longer needed
      checkoutId: checkout._id,
    } as VolatileCartResponse;
  }
}
